import { Component, Input, OnInit } from '@angular/core';
import { TranslateService }         from '@ngx-translate/core';
import { NgbActiveModal }           from '@ng-bootstrap/ng-bootstrap';

import { API }          from '../api/api.constant';
import { Table }        from '../table/types/table';
import { VehicleModel } from './models/vehicle';

@Component({
  selector   : 'wor-vehicle-branch-history',
  template: require('./vehicle.branch-history.component.html')
})
export class VehicleBranchHistoryComponent implements OnInit {
  @Input() invoices: Array<any>;
  @Input() vehicle : VehicleModel;

  tableSettings: Table;

  constructor (
    public  activeModal     : NgbActiveModal,
    private translateService: TranslateService
  ) {}

  ngOnInit () : void {
    this.tableSettings = {
      columns: [
        {
          field : 'store_name',
          header: {
            text: 'Store Name'
          }
        },
        {
          field : 'invoice_number',
          header: {
            text: this.translateService.instant('GENERAL_SPACE.FIELD.REFERENCE')
          }
        },
        {
          field : 'post_date',
          header: {
            text: this.translateService.instant('GENERAL_SPACE.FIELD.POST_DATE')
          },
          pipe  : 'globalDate'
        },
        {
          field : 'invoice_type',
          header: {
            text: this.translateService.instant('JS_SPACE.COLUMNS.TRAN_TYPE')
          },
          pipe  : 'invoiceType'
        },
        {
          field : 'invoice_status',
          header: {
            text: this.translateService.instant('GENERAL_SPACE.FIELD.STATUS')
          },
          pipe  : 'invoiceStatus'
        },
        {
          field : 'cash_or_account',
          header: {
            text: this.translateService.instant('GENERAL_SPACE.FIELD.TYPE')
          },
          pipe  : 'customerType'
        },
        {
          field : 'total',
          header: {
            text: this.translateService.instant('JS_SPACE.COLUMNS.AMOUNT')
          },
          pipe  : 'globalCurrency'
        },
        {
          field : 'balance_due',
          header: {
            text: this.translateService.instant('JS_SPACE.COLUMNS.BALANCE')
          },
          pipe  : 'globalCurrency'
        }
      ],
      empty: {
        text: this.translateService.instant('QUERY_DROPDOWN_SPACE.GRID.NO_INVOICES_FOUND')
      },
      pagination: {
        enabled: false
      },
      rows: {
        highlight: {
          enabled: true
        }
      },
      sorting: {
        enabled: false
      },
      static: true
    };
  }

  rowSelected ( event : any ) : void {


    window.open(`${ API.url }/reports/jasper_invoice/${ event.row.id }.pdf`, '_blank');


    };


  }
